import { Component, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'app-print-logo',
	templateUrl: './print-logo.component.html',
	styleUrls: ['./print-logo.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PrintLogoComponent {

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/print/logo/print-logo.component.ts